<template>
  <div class="estimator_item">
    <div class="title_container">
        <span class="title">{{itemTitle}}</span>
        <tooltip v-if="this.tooltipText" :tooltip-text=this.tooltipText></tooltip>
    </div>
    <div>
        <span class="price">{{secondPrice}}</span>
        <span class="value">{{itemValue}}</span>
    </div>
    <!-- <div>
        <span class="label">il 2° anno </span>
        <span>{{secondPrice}}</span>
    </div> -->
  </div>
</template>

<script>

  import tooltip from './Tooltip.vue';

  export default {
    name: "EstimatorItem",

    components: {tooltip},

    props: {
      itemTitle: String,
      itemValue: String,
      itemPrice: Number,
      tooltipText: String,
    },

    data() {
      return {
        loaded: true,
        commodity: '',
        tab: "path",
        exitPage: {},
        recap: [],
        path: [],
        answersPath: []
      }
    },

    computed: {
      secondPrice: function() {
        let discount = this.itemPrice / 100 * 90;
        return discount.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
      },

      firstPrice: function() {
        let discount = this.itemPrice / 100 * 80;
        return discount.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
      }
    }
  };

</script>

<style scoped lang="scss">
  .estimator_item {
    .title_container {
      display: flex;
      padding-bottom: 15px;
      border-bottom: 1px solid #eaeaea;

      .title {
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
        color: #7fa545;
        margin-right: 10px;
      }
    }

    .price {
      font-size: 40px;
      font-weight: bold;
    }
  }
</style>